import { Right } from "@insightfulscience/shared-utils/either";

import { gqlResultToEither } from "../../utils/gql";
import routes from "../../routes";
import { ref } from "../../routing-utils";
import REQUEST_TRIAL from "./requestTrial.mutation.graphql";
import START_TRIAL from "./startTrial.mutation.graphql";

const trialService = ({ gqlClient, authService, routingService }) => ({
	async requestTrial(email) {
		const trialId = await gqlClient(REQUEST_TRIAL, { email }).then(
			result => result.requestTrial.trialId,
		);

		await authService.signOut({ localOnly: true });

		return authService.toAuth(
			{
				email,
				redirectPath: `${routes.freeTrialComplete}?trialId=${trialId}`,
				quickFlow: true,
				forceSignOut: true,
			},
			{
				method: "push",
			},
		);
	},
	async startTrial(trialId) {
		const startTrialResult = await gqlClient(START_TRIAL, {
			trialId,
		})
			.then(result => result.startTrial)
			.then(gqlResultToEither);

		if (startTrialResult.isLeft()) return startTrialResult;

		routingService.push(
			ref(routes.subscription.dashboard, {
				subscriptionId: startTrialResult.right.subscription.id,
			}),
		);

		return Right(undefined);
	},
});

export default trialService;
